import { useVouchingCredits } from '../../../hooks/useVouchingCredits';
import './VouchingCreditsStrip.scss';

export function VouchingCreditsStrip() {
  const enabled = import.meta.env.VITE_ENABLE_VOUCHING === 'true';
  const { available, committed } = useVouchingCredits();
  if (!enabled) return null;
  return (
    <div className="vouching-credits">
      <span className="vouching-credits__label">Vouching credits</span>
      <span className="vouching-credits__value">
        <strong>{available}</strong> available · <strong>{committed}</strong>{' '}
        committed
      </span>
    </div>
  );
}
